import React, { useEffect } from "react";

export default function MaintenanceItems({ maintenanceItems, setMaintenanceItems }) {
  const addMaintenanceItem = () => {
    setMaintenanceItems((prevItems) => [...prevItems, { item: "", quantity: 0 }]);
  };

  const deleteMaintenanceItem = (index) => {
    setMaintenanceItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleMaintenanceItemChange = (index, field, value) => {
    console.log(maintenanceItems)
    setMaintenanceItems((prevItems) => prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item)));
  };
  useEffect(() => {
    console.log(maintenanceItems);
  }, [maintenanceItems]);

  // useEffect(() => {
  //   if (maintenanceItems && ContractId) {
  //     const filtered = terms.filter((term) => term.title === "main");
  //     setMaintenanceItems(filtered);
  //   }
  // }, [terms]);

  return (
    <div className="carousel-item">
      <div className="mt-5 pt-4">
        <form className="container">
          <h3 className="mb-3">مفردات الصيانة</h3>
          <div className="row">
            {maintenanceItems.map((item, index) => (
              <React.Fragment key={index}>
                <div className="col-md-6 mb-3">
                  <label htmlFor={`maintenance-item-${index}-desc`} className="form-label">
                    مفردة الصيانة
                  </label>
                  <div className="input-group">
                    <input type="text" className="form-control" id={`maintenance-item-${index}-desc`} value={item.item} onChange={(e) => handleMaintenanceItemChange(index, "item", e.target.value)} />
                    <button type="button" className="btn btn-danger" onClick={() => deleteMaintenanceItem(index)}>
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor={`maintenance-item-${index}-qty`} className="form-label">
                    الكمية
                  </label>
                  <input type="number" className="form-control" id={`maintenance-item-${index}-qty`} value={item.quantity || ""} onChange={(e) => handleMaintenanceItemChange(index, "quantity", e.target.value)} />
                </div>
              </React.Fragment>
            ))}

            <div className="col-12">
              <button className="btn btn-primary mt-2" type="button" onClick={addMaintenanceItem}>
                +
              </button>
            </div>
          </div>
        </form>
      </div>

      <div className="d-flex justify-content-between mx-5 my-3">
        <button className="btn" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span>السابق</span>
        </button>
        <button className="btn btn-primary" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          التالي
        </button>
      </div>
    </div>
  );
}
